export const meta: BlockMeta = {
  title: "Inline Media Item",

  blockStyles: [
    { name: "body-m", label: "Body M", isDefault: true },
    { name: "body-s", label: "Body S" },
    { name: "body-xs", label: "Body XS" },
  ],
}

import { AdminMessage } from "@components/atoms/AdminMessage"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useBlockContext } from "eddev/blocks"

export default defineBlock("content/inline-media-item", (props) => {
  const info = useBlockContext()
  const index = info?.index || 0
  const blockStyle = (props as { blockStyle?: string }).blockStyle || "body-m"

  return (
    <Appear className="inline-media-item w-full relative flex flex-col gap-5" delay={50 * index}>
      {!props.image?.mediaItemUrl && !props.video?.mediaItemUrl && (
        <AdminMessage>No media added. Select this block and edit in the sidebar.</AdminMessage>
      )}

      {props.image && !props.video && (
        <>
          <ResponsiveImage
            {...props.image}
            className={cn("inline-media-item-media w-full h-auto", props.mobileImage?.mediaItemUrl && "hidden")}
          />
          {props.mobileImage?.mediaItemUrl && (
            <ResponsiveImage {...props.mobileImage} className="inline-media-item-media md:hidden w-full h-auto" />
          )}
        </>
      )}

      {props.video?.mediaItemUrl && (
        <>
          <video
            className={cn("inline-media-item-media w-full h-auto", props.mobileVideo?.mediaItemUrl && "hidden")}
            autoPlay
            playsInline
            loop
            muted
          >
            <source src={props.video.mediaItemUrl} type="video/mp4" />
          </video>
          {props.mobileVideo?.mediaItemUrl && (
            <video className="inline-media-item-media md:hidden w-full h-auto" autoPlay playsInline loop muted>
              <source src={props.mobileVideo.mediaItemUrl} type="video/mp4" />
            </video>
          )}
        </>
      )}

      <EditableText
        store="caption"
        placeholder="Add optional caption"
        className={cn(
          "inline-media-item-caption w-full",
          props.captionStyle === "left" && "md:w-[55%]",
          props.captionStyle === "right" && "md:w-[55%] self-end",
          `style-${blockStyle}`,
        )}
      />
    </Appear>
  )
})
